import api from "../config/api";

export const fetchAllUser = async () => {
  const res = await api.get("/user/");
  return res.data.data;
};

export const fetchUserById = (userId) => {
  const res = api.get(`/user/?id=${userId}`);
};

export const createUser = async (postData) => {
  const res = await api.post(`/user/`, postData);
  return res.data;
};

export const updateUser = async (userId, postData) => {
  const res = await api.put(`/user/?id=${userId}`, postData);
  return res.data;
};

export const deleteUser = async (userId) => {
  const res = await api.delete(`/user/?userId=${userId}`);
  return res.data;
};
